import { render, staticRenderFns } from "./NewEntryComponent.vue?vue&type=template&id=3ddd8ab9&"
import script from "./NewEntryComponent.vue?vue&type=script&lang=ts&"
export * from "./NewEntryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports